module.exports = __webpack_public_path__ + "static/img/team2.4939278.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channels/team2.png
// module id = V274
// module chunks = 1